import { Question } from '../../question.class';
import { removeEmptyNumberOptions } from '../functions/removeEmptyNumberOptions.fn';
import { getPropertyDescriptor } from '../../../../functions';

const type = 'afterschool';
let QuestionCanHaveQuotaOptions = getPropertyDescriptor(Question.prototype, 'canHaveQuotaOptions');
Object.defineProperties(Question.prototype, {
    canHaveQuotaOptions: {
        get: function(): boolean {
            return QuestionCanHaveQuotaOptions.get.apply(this);
        },
        set: function(v: boolean) {
            if (this.type === type) {
                this.set('canHaveQuotaOptions', v);
            } else {
                return QuestionCanHaveQuotaOptions.set.apply(this, [v]);
            }

        }
    }    
});

let QuestionOnComposeInit = Question.prototype.onComposeInit;
Question.prototype.onComposeInit = function(...args) {
  if (args[0] === type) {
    (<Question>this).deleteOptions(undefined);
    QuestionOnComposeInit.apply(this, args);
  } else {
    QuestionOnComposeInit.apply(this, args);
  }
};
let QuestionOnComposeDestroy = Question.prototype.onComposeDestroy;
Question.prototype.onComposeDestroy = function(...args) {
  if (args[0] === type) {
    (<Question>this).deleteOptions(undefined);
    QuestionOnComposeDestroy.apply(this, args);
  } else {
    QuestionOnComposeDestroy.apply(this, args);
  }
};

let QuestionOnComposeBlur = Question.prototype.onComposeBlur;
Question.prototype.onComposeBlur = function(...args) {
  if (this.type === type) {
    removeEmptyNumberOptions(this,  'afterschool');
    QuestionOnComposeBlur.apply(this, args);
  } else {
    QuestionOnComposeBlur.apply(this, args);
  }
};
let QuestionAddOption = Question.prototype.addOption;
Question.prototype.addOption = function (...args) {
  if (this.type === type) {
    args[0] = {...args[0], type:'afterschool', ...(this.canHaveQuotaOptions === true? {accept:0, waitlist:0}:{})};
    return QuestionAddOption.apply(this, args);
  } else {
    return QuestionAddOption.apply(this, args);
  }
}
console.log("question type afterschool is added");